import { createRoutesManifest } from "../server/createRoutesManifest";
import { getRoutePaths } from "../utils/routeIndex";
function getManifest(param) {
  var { routerRoot, ignoredRouteFiles, routePaths: routePathsIn } = param;
  var routePaths = routePathsIn !== null && routePathsIn !== void 0 ? routePathsIn : getRoutePaths(routerRoot, ignoredRouteFiles);
  return createRoutesManifest(routePaths, {
    platform: "web"
  });
}
export {
  getManifest
};
//# sourceMappingURL=getManifest.js.map
